import { render, staticRenderFns } from "./RuleCRUpdate.vue?vue&type=template&id=1107cf96&"
import script from "./RuleCRUpdate.vue?vue&type=script&lang=js&"
export * from "./RuleCRUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports